module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-12.e00ba38e.jpg";